import { useRef } from "react";
import { getPlanetStyle } from "../utils/format";
import { getTrendingBooks } from "../modals/TrendingModal";
import MonthlyChart from "../components/MonthlyChart";
import HotBooks from "../components/HotBooks";
import RegionBooks from "../components/RegionBooks";
import { COLOR_UNLOCK, COLOR_HINT_FROM, TRAVELER_UNLOCK, FOX_UNLOCK } from "../data/constants";
import PlanetTraveler from "../components/PlanetTraveler";
import PlanetFox from "../components/PlanetFox";
import { readBooks } from "../utils/bookState";
import { TYPES } from "../data/bookPti";

const PlanetSection = ({ books, allBooks, users, uid, visitorCount = 0, completedBooks, incompleteBooks, friendCount, onUserClick, onFriendsClick, onRecentClick, onTrendingClick, onReadingClick, setActiveTab, setSearchQuery, scrollToBooks, onShowUserSearch, onShowConstellation, readyConstellations = 0, onMonthlyClick, onAddClick, onAddWishClick, canAdd, onBookPtiClick, myType }) => {
  // 내 행성 색. 유저마다 profiles.planet_colors 에 다른 값이 들어 있다.
  const me = (users || []).find((u) => u.id === uid);
  /** 나를 뺀 행성 수. 게스트는 프로필이 없어 애초에 세지 않는다. */
  const otherPlanets = (users || []).filter((u) => u.id !== uid).length;
  /** 여행자는 담아둔 책을 빼고 센다 (constants.js TRAVELER_UNLOCK) */
  const readCount = readBooks(books, uid).length;


  /* 커서 옆에 붙는 안내. state 로 좌표를 들고 있으면 마우스가 움직일 때마다
     이 칸 전체가 다시 그려진다 — ref 로 노드를 직접 옮긴다.
     position:fixed 라 조상 요소에 잘리지 않고, 화면 오른쪽 끝에서는
     커서 왼쪽으로 넘겨 밖으로 나가지 않게 한다. */
  const tipRef = useRef(null);
  const moveTip = (e) => {
    const el = tipRef.current;
    if (!el) return;
    const w = el.offsetWidth;
    const x = Math.min(e.clientX + 16, window.innerWidth - w - 8);
    el.style.transform = `translate(${Math.max(8, x)}px, ${e.clientY + 18}px)`;
  };


  return (
    <div className="planet-section">
      <div className="planets-row">
        <div className="planet-col">
          {/* 영어 라벨만으로는 처음 온 사람이 무엇인지 알 수 없다.
              한글 이름과 한 줄 설명을 함께 둔다. */}
          <div className="planet-section-label">my planet · 나의 행성</div>
          <div className="planet-section-desc">읽은 책이 쌓여 만들어지는 나의 우주</div>
          <div className={readCount >= TRAVELER_UNLOCK ? "planet-wrap with-traveler" : "planet-wrap"} onClick={() => onUserClick("me")} onMouseMove={moveTip}>
            <div className="planet-ring" />
            {incompleteBooks.length > 0 && (
              <div className="atmo-books" onClick={(e) => { e.stopPropagation(); onReadingClick(); }}>
                {incompleteBooks.slice(0, 5).map((b, i) => (
                  <div key={i} className={`atmo-book atmo-b${i + 1}`}>{b.emoji || "📖"}</div>
                ))}
              </div>
            )}
            <div className="my-planet" style={getPlanetStyle(me)}>
              <span className="planet-book-count">{books.length}</span>
              {readCount >= TRAVELER_UNLOCK && <PlanetTraveler />}
              {readCount >= FOX_UNLOCK && <PlanetFox />}
            </div>
            {/* 행성이 눌린다는 걸 알려준다. 커서가 있는 기기에서만 뜬다 —
                터치에는 hover 가 없으므로 아래 버튼이 계속 그 몫을 한다. */}
            <div className="planet-tip" ref={tipRef} aria-hidden="true">독서기록 보러가기 →</div>
          </div>

          {/* 북BTI 유형은 이름표로 행성에 붙인다. 버튼이 아니라 '나는 이런
              독자다' 라는 표시여서, 담기 버튼들 위 이 자리가 맞다.
              눌러도 되게 해서 결과로 돌아갈 길은 열어 둔다. */}
          {myType && TYPES[myType] && onBookPtiClick && (
            <button className="planet-type" onClick={onBookPtiClick}>
              <span aria-hidden="true">{TYPES[myType].icon}</span> {TYPES[myType].name}
            </button>
          )}

          {/* 여기서부터 누르는 것들을 모은다. 담기 → 수치 → 이동 순이고,
              '다녀갔어요' 는 읽고 지나가는 것이라 그 아래로 내린다.
              사이에 끼면 흐름이 끊긴다. */}

          {/* 담는 버튼을 행성 바로 아래에 둔다. 화면 오른쪽 아래에 붙여두면
              스크롤 어디서나 닿지만, 행성과 떨어져 있어 무엇에 담는 것인지
              한 번 더 생각해야 했다. */}
          {canAdd && (
            <div className="planet-add">
              {/* ＋ 는 글자로 둔다. 아이콘 안에 작게 그려 넣으면 15px 에서
                  뭉개져 읽히지 않고, 앱은 이미 '＋ 첫 책 등록하기',
                  '+ 문장 옮기기' 처럼 글자로 쓰고 있다. */}
              <button className="planet-add-btn wish" onClick={onAddWishClick}>＋ 읽고 싶은 책</button>
              <button className="planet-add-btn" onClick={onAddClick}>＋ 독서 등록</button>
            </div>
          )}

          {/* 수치는 행성의 값이라 행성 가까이 둔다 */}
          <div className="planet-stats">
            <div className="planet-stat-chip" onClick={() => { setActiveTab("completed"); setSearchQuery(""); if (scrollToBooks) scrollToBooks(); }}>
              <span className="stat-num">{completedBooks.length}</span><span className="stat-label">읽은 책</span>
            </div>
            {/* 목록 탭을 바꾸지 않고 따로 띄운다. 탭이 셋으로 정리되면서
                읽는 중에 해당하는 탭이 없어져, 눌러도 탭 줄에 아무것도
                켜지지 않았다. */}
            <div className="planet-stat-chip" onClick={onReadingClick}>
              <span className="stat-num" style={{color:"#e89b5a"}}>{incompleteBooks.length}</span>
              <span className="stat-label" style={{color:"#e89b5a"}}>읽는 중</span>
            </div>
            <div className="planet-stat-chip" onClick={onFriendsClick}>
              <span className="stat-num" style={{color:"var(--teal)"}}>{friendCount}</span>
              <span className="stat-label" style={{color:"var(--teal)"}}>이웃 행성</span>
            </div>
          </div>

          {/* '내 행성의 독서기록 보기' 버튼을 걷어냈다. 아래 막대에 '내 행성'
              칸이 생기면서 같은 곳으로 가는 문이 한 화면에 둘이 되었다.
              행성 그림 자체가 여전히 눌리므로 길이 막히지는 않는다. */}
          {/* 북BTI 는 내 행성 칸의 맨 아래에 둔다. 우주 칸의 칩·버튼들 사이에
              두면 남의 것을 보러 가는 것들과 섞인다. 여기는 내 것을 보는
              자리다. 하고 나면 유형이 남아 결과로 가는 문이 된다. */}
          {onBookPtiClick && !(myType && TYPES[myType]) && (
            <button className="planet-pti" onClick={onBookPtiClick}>📖 북BTI 해보기 →</button>
          )}
          {/* 해금이 가까워졌을 때만 알린다. 1권일 때부터 보이면 잔소리다. */}
          {books.length >= COLOR_HINT_FROM && books.length < COLOR_UNLOCK && (
            <div className="planet-unlock-hint">
              {COLOR_UNLOCK - books.length}권 더 담으면 행성 색을 고를 수 있어요
            </div>
          )}
          {/* 색을 연 다음 목표. 두 안내가 한꺼번에 뜨지 않게 색 잠금이 풀린 뒤부터. */}
          {books.length >= COLOR_UNLOCK && readCount < TRAVELER_UNLOCK && (
            <div className="planet-unlock-hint">
              {TRAVELER_UNLOCK - readCount}권 더 기록하면 행성에 여행자가 찾아와요
            </div>
          )}
          {/* 여행자가 온 뒤의 다음 목표. 한 번에 하나만 보인다. */}
          {readCount >= TRAVELER_UNLOCK && readCount < FOX_UNLOCK && (
            <div className="planet-unlock-hint">
              {FOX_UNLOCK - readCount}권 더 기록하면 여우가 찾아와요
            </div>
          )}

        </div>

        <div className="planet-col">
          {/* '다른 행성들' 이라고 불렀는데 이 칸에는 행성(사람)만 있는 게
              아니다. 별자리·많이 담은 책·전체 권수까지 들어 있어 그냥
              우주다. 이름을 칸의 내용에 맞춘다. */}
          <div className="planet-section-label" style={{color:"#8b7ec8"}}>universe · 우주</div>
          <div className="planet-section-desc">지금 이 우주에서 함께 읽고 있는 책</div>
          {/* 이름만으로는 무엇이 열리는지 알기 어려워 설명을 함께 둔다.
              바깥에 늘어놓으면 우주 화면이 설명서처럼 보이므로 버튼 안에 넣고,
              제목 옆에 붙여 한 줄로 만든다 — 두 줄이면 버튼이 너무 커진다. */}
          <div className="explore-btns">
          <button className="btn-user-search" onClick={onShowUserSearch}>
            <span className="btn-explore-title">
              🔭 다른 행성 보기
              {/* 몇 곳이 있는지 보이면 눌러볼 이유가 생긴다.
                  이웃이 아닌 곳만 세면 다 맺은 사람에게 0 이 떠서 버튼이 죽는다. */}
              {otherPlanets > 0 && <span className="btn-explore-count">{otherPlanets}</span>}
            </span>
            <span className="btn-explore-desc">이웃 추가하기</span>
          </button>
          {/* '다른 책 탐험하기' 를 걷어낸 자리다. 그 버튼은 ＋독서 등록과
              같은 검색창(useBookSearch)이었고, 눌러 들어간 책 화면은
              213권 중 189권이 독자 1명이라 대개 출판사 소개문 하나였다.
              남의 것을 보러 가는 문 대신 내 것이 만들어지는 것을 둔다. */}
          <button className="btn-user-search btn-constellation" onClick={onShowConstellation}>
            <span className="btn-explore-title">
              ✦ 내 별자리
              {readyConstellations > 0 && <span className="btn-explore-count">{readyConstellations}</span>}
            </span>
            <span className="btn-explore-desc">읽은 책으로 만들기</span>
          </button>
          {/* 무루에 등록된 모든 책(muroo.kr/booklist). 예전엔 아래 칩 줄에
              "N권이 MUROO에 등록되어 있어요 →" 로 있었는데, 그 줄은 숫자와
              도서관 자료 칩이고 이건 다른 곳으로 가는 문이라 이 묶음에 둔다.
              앱 밖의 정적 페이지라 새 탭으로 연다. */}
          <a
            className="btn-user-search btn-booklist"
            href="https://muroo.kr/booklist"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="btn-explore-title">
              📚 무루의 책
              {allBooks.length > 0 && <span className="btn-explore-count">{allBooks.length}</span>}
            </span>
            <span className="btn-explore-desc">등록된 책 둘러보기</span>
          </a>
          </div>
          {/* 최근 등록·인기 책과 전체 권수는 소식이다. 탐험 버튼이 이 칸의
              주된 동작이라 그 위에 두고, 소식은 아래로 내린다. */}
          {/* 성운 그림을 걷어냈다. 160px 짜리 원에 ✦ 하나가 떠 있을 뿐
              읽을 것이 없었고, 배지와 등록 권수를 그 위에 absolute 로 얹느라
              여백까지 손으로 맞춰야 했다. 이제 그냥 흐름대로 선다. */}
          <div className="stardust-wrap">
            {(() => {
              const ownedBookIds = new Set((users || []).flatMap(u => u.bookIds || []));
              const now = new Date();
              const weekAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
              // addedDate(=books.created_at) 를 쓴다. registeredDate 는
              // 사용자가 고치는 날짜라 '새로 들어온 책' 과 뜻이 다르다.
              const recentCount = allBooks.filter(b => {
                if (!ownedBookIds.has(b.id)) return false;
                if (!b.addedDate) return false;
                const [y, m, d] = b.addedDate.split(".").map(Number);
                return new Date(y, m - 1, d) >= weekAgo;
              }).length;
              // 가장 많은 사람이 담은 책 (팝업으로 보여준다)
              const trendingCount = getTrendingBooks(allBooks).length;
              // 등록 권수는 배지와 상관없이 늘 보여준다. 예전엔 한 덩어리라
              // 배지가 하나도 없는 날엔 권수까지 함께 사라졌다.
              return (
                <>
                  <div className="stardust-badges-row">
                    {recentCount > 0 && (
                      <div className="stardust-recent" onClick={() => { if (onRecentClick) onRecentClick(); }}>
                        🔥 최근 7일 +{recentCount}
                      </div>
                    )}
                    {trendingCount > 0 && (
                      <div className="stardust-recent stardust-trending" onClick={() => { if (onTrendingClick) onTrendingClick(); }}>
                        ✨ 많이 담은 책 {trendingCount}
                      </div>
                    )}
                    {/* '이달의 책 · 이달의 이야기' 칩을 걷어냈다. 이달에 담긴 책과
                        남긴 이야기는 '다른 행성' 탭의 이야기 목록에 이미 시간순으로
                        흐르고 있어, 같은 것을 여는 문이 두 개였다. */}
                  </div>
                  <div className="stardust-below">
                    {/* 예전에는 여기 '넓어지는 우주'(ExpandingUniverse)가 있었다.
                        권수만큼 점이 흩어지는 그림인데 눌러도 아무 일이 없는
                        장식이었다. 매일 바뀌고 누를 수 있는 것으로 바꾼다 —
                        다시 올 이유가 되는 쪽이 낫다. */}
                    {/* 도서관 자료는 따로 묶는다. 위의 '많이 담은 책' 은 무루
                        사용자들의 기록이고 이 둘은 전국 도서관 대출 기록인데,
                        같은 칩 모양으로 한 줄에 서 있어 같은 종류의 숫자로 읽혔다. */}
                    <div className="library-group">
                      <div className="library-label">library · 도서관 대출 기록</div>
                      <HotBooks uid={uid} myBooks={books} canAdd={canAdd} />
                      <RegionBooks uid={uid} myBooks={books} canAdd={canAdd} />
                    </div>
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      </div>
      {/* 소식은 두 칸 아래로 내린다. 읽고 지나가는 것이라 누르는 것들
          사이에 끼면 흐름이 끊겼다. */}
      {/* 아무도 안 왔으면 보여주지 않는다. '0명이 다녀갔어요' 는
          소식이 아니라 핀잔이다. 주인 홈에서만 보이는 값이다. */}
      {visitorCount > 0 && (
        <div className="planet-visits">
          🔭 {me?.name}님 행성에 <b>{visitorCount}</b>명이 다녀갔어요
        </div>
      )}
      {/* 걸어둔 문장은 여기 두지 않는다. 같은 문장을 내 행성(ProfileHero)
          에서도 그리고 있어, 한 사람의 같은 글이 두 화면에 겹쳤다.
          문장은 내 행성에서 읽는다. */}
      {/* 두 칸 안에 두면 340px 로 눌린다. 그래프는 폭이 넓을수록
          읽기 쉬우므로 칸 밖으로 내보낸다.
          올해 완독이 한 권도 없으면 그리지 않는다. */}
      <MonthlyChart books={books} uid={uid} onSeeAll={onMonthlyClick} />
    </div>
  );
};

export default PlanetSection;
